import { login, getUserInfo } from '@/api/api'

const state = {
  token: sessionStorage.getItem('token') || '',
  user: {}
}
const mutations = {
  // // 存入token
  updateToken(state, payload) {
    state.token = payload
    sessionStorage.setItem('token', payload)
  },
  // // 存入个人信息
  updateUserInfo(state, payload) {
    state.user = payload
  },
  // // 退出清除
  // removeToken(state) {
  //   state.token = null
  //   removeToken()
  // }
}
const actions = {
  // 获取token
  async login(context, data) {

    const res = await login(data)
    // console.log(res)
    // 如果有就存入
    context.commit('updateToken', res.data.data)
  },
  // // 获取个人信息
  async getUserInfo(context) {
    const res = await getUserInfo()

    context.commit('updateUserInfo', res.data.data)
    sessionStorage.setItem('user', JSON.stringify(res.data.data))
    // return 出去的数据可以用 store.dispatch 接收
    return res
  },
  // async logout (context) {
  //   context.commit('removeToken')
  //   context.commit('updateUserInfo', {})
  //   resetRouter()
  // }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
